import React from 'react'
import { t } from 'ttag'
import { shallowEqual, useSelector } from 'react-redux'
import { getTimer } from 'ducks/timer'
import { formatTimer } from 'utils/stringFormat'
import { getGMA } from 'ducks/respondent'
import { ProgressBar } from 'components/shared/ProgressBar/ProgressBar'

const AbilityBar = () => {
  const { totalAnswers, totalQuestions } = useSelector(getGMA, shallowEqual)
  const { secondsLeft } = useSelector(getTimer)

  return (
    <ProgressBar
      timeLabel={`${t`Remaining time`}:`}
      timeValue={formatTimer(secondsLeft)}
      totalAnswers={totalAnswers}
      totalQuestions={totalQuestions}
    />
  )
}

export default AbilityBar
